import { Test } from '@/types/database';
import { Box, Paper, PaperProps, Typography } from '@mui/material';
import { FC } from 'react';
import IconText from './IconText';
import { getLabelColor, getLabelStatus } from '@/utils/helpers';

interface Props extends Partial<Test>, PaperProps {}

const TestCard: FC<Props> = ({ status, createdAt, notes, ...props }) => {
  const statusProps = STATUS_MAP[status] || ({} as StatusProp);
  return (
    <Paper
      variant="outlined"
      square
      onClick={props.onClick}
      sx={{
        p: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        ...props.sx,
      }}
    >
      <Typography>{createdAt?.toDate().toLocaleDateString()}</Typography>
      {notes && <Typography variant="body2">{notes}</Typography>}
      <Box>
        <IconText
          fontWeight="bolder"
          gap={2}
          iconProps={{ height: 32 }}
          iconSide="right"
          icon={statusProps.icon}
          color={getLabelColor(status)}
        >
          {getLabelStatus(status)}
        </IconText>
      </Box>
    </Paper>
  );
};

export default TestCard;

interface StatusProp {
  icon: string;
  color: 'success' | 'error' | 'warning';
  label: string;
}

const STATUS_MAP: Record<Test['status'], StatusProp> = {
  'pending-patient': {
    icon: 'mdi:calendar',
    color: getLabelColor('pending-patient'),
    label: getLabelStatus('pending-patient'),
  },
  submitted: {
    icon: 'fluent:checkmark-circle-20-filled',
    color: getLabelColor('submitted'),
    label: getLabelStatus('submitted'),
  },
  'reviewed-by-doctor': {
    icon: 'fluent:checkmark-circle-20-filled',
    color: getLabelColor('reviewed-by-doctor'),
    label: getLabelStatus('reviewed-by-doctor'),
  },
};
